export default __webpack_public_path__ + "static/media/soda.5d4fe98e.png";